import React from "react";

import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import Filters from "./components/filters/Filters";
import { UniversityCard } from "./components/universityCard";
import MapChart from "./components/map/Map";

import { useSelector } from "react-redux";
import { gql, useQuery } from "@apollo/client";

const GET_COLLEGELIST = gql`
  query Query(
    $getCollegeListPageNo: Int
    $getCollegeListLimit: Int
    $getCollegeListFilters: getCollegeListFilter
  ) {
    getCollegeList(
      pageNo: $getCollegeListPageNo
      limit: $getCollegeListLimit
      filters: $getCollegeListFilters
    ) {
      limit
      pageNo
      list {
        name
        location
        campusImage
        localeClass
        rankingsBestColleges {
          total
          value
        }
        collegeId
      }
      count
      allCollegeGeo {
        latitude
        longitude
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  cardContentRoot: {
    "&.MuiCardContent-root:last-child": {
      paddingBottom: "8px",
    },
    padding: "8px",
  },
  cardRoot: {
    borderRadius: "12px",
  },
}));

export default () => {
  const classes = useStyles();

  const [pageNo, setPageNo] = React.useState(1);
  const [limit] = React.useState(12);

  const { collegeFilters } = useSelector((state) => ({
    collegeFilters: state.college.filters,
  }));

  const { loading, data, error } = useQuery(GET_COLLEGELIST, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeListPageNo: pageNo,
      getCollegeListLimit: limit,
      getCollegeListFilters: {
        ...collegeFilters,
        radius: collegeFilters.radius ? collegeFilters.radius : 0,
      },
    },
  });

  return (
    <Container>
      <Box>
        <Filters />
      </Box>
      <Box mt={5}>
        {loading ? (
          <Box className="text-center">
            <CircularProgress style={{ color: "#3699FF" }} />
          </Box>
        ) : (
          ""
        )}
        {error ? <p className="text-center">Something went wrong</p> : ""}
        {!loading && !error ? (
          data.getCollegeList.count ? (
            <>
              <Grid
                container
                alignContent="center"
                justify="center"
                spacing={0}
              >
                {/* {pageNo === 1 ? (
                  <Grid sm={12} md={6} style={{ textAlign: "center" }}>
                    <Box m={2}>
                      <Card classes={{ root: classes.cardRoot }}>
                        <CardContent
                          classes={{ root: classes.cardContentRoot }}
                        >
                          <MapChart
                            collegeLocations={data.getCollegeList.allCollegeGeo}
                          />
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                ) : (
                  ""
                )} */}
                {data.getCollegeList.list.map((c) => (
                  <Grid sm={12} md={3}>
                    <UniversityCard college={c} key={c.collegeUnitId} />
                  </Grid>
                ))}
              </Grid>
              <br />
              <Box my={3} display="flex" justifyContent="center">
                <Pagination
                  count={Math.ceil(
                    data.getCollegeList.count / data.getCollegeList.limit
                  )}
                  page={data.getCollegeList.pageNo}
                  onChange={(e, pageNo) => setPageNo(pageNo)}
                  variant="outlined"
                  shape="rounded"
                />
              </Box>
            </>
          ) : (
            <Typography
              variant="h6"
              className="pt-5"
              style={{ color: "grey" }}
              align="center"
            >
              No results found
            </Typography>
          )
        ) : (
          ""
        )}
      </Box>
    </Container>
  );
};
